import { Typography, useTheme } from '@mui/material'
import React from 'react'

const CountBadge = ( { value = 0 } ) => {

    const { palette } = useTheme()

    return (
        <Typography minWidth="22px" fontSize="12px" display="flex" alignItems="center" justifyContent="center" component="span" height="fit-content" borderRadius="5px" bgcolor={palette.primary.light + "66"} color={palette.primary.contrastText} padding="2px 5px" >
            {value}
        </Typography>
    )
}

export default CountBadge
